<script>
import List from './List.vue'

export default {
    /*
    |--------------------------------------------------------------------------
    | Component > extends
    |--------------------------------------------------------------------------
    */
    extends: List, // End of Component > extends

    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */
    watch: {
        model(value) {
            if (value) {
                let selectedItem = this.options.find(
                    (item) => item._id === value
                )

                //console.log('occupationInfo.workType ' + selectedItem.title)
                this.$store.commit('setValue', {
                    key: 'isIndustrial',
                    value: selectedItem.isIndustrial,
                })

                this.$store.commit('updateField', {
                    key: 'occupationInfo.workType',
                    value: selectedItem.title,
                })

                // this.$store.commit('setValue', {
                //     key: 'occupationInfo.workType',
                //     value: selectedItem.title,
                // })

                if (!selectedItem.isIndustrial) {
                    this.$store.commit('updateField', {
                        key: 'occupationInfo.industryId',
                        value: null,
                    })
                }
            }
        },
    }, // End of Component > watch
}
</script>
